module.exports = __webpack_public_path__ + "static/media/med_slide2.27aaee65.jpg";